import styled from 'styled-components';

export const View = styled.div`
  display: flex;
  flex-direction: column;
`;
